import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { logError } from 'utils/logger';
import { EMPTY_LEAVES_BY_STATUS } from '../constants';
import { getMyLeaves } from '../service/myLeaves.service';

/**
 * Fetches and manages leave applications for the logged-in employee.
 *
 * @param {string|number} employeeId
 * @returns {{
 *   leavesByStatus: { pending: Array, approved: Array, rejected: Array },
 *   loading: boolean,
 *   refresh: Function
 * }}
 */
export function useMyLeaves(employeeId) {
  const [leavesByStatus, setLeavesByStatus] = useState(EMPTY_LEAVES_BY_STATUS);
  const [loading, setLoading] = useState(false);

  const fetchLeaves = useCallback(async () => {
    if (!employeeId) return;
    setLoading(true);
    try {
      const data = await getMyLeaves(employeeId);
      setLeavesByStatus(data);
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to fetch user leaves',
          error: err,
          code: 'MY_LEAVES_FETCH_FAILED',
        }),
      );
      setLeavesByStatus(EMPTY_LEAVES_BY_STATUS);
    } finally {
      setLoading(false);
    }
  }, [employeeId]);

  useEffect(() => {
    fetchLeaves();
  }, [fetchLeaves]);

  return { leavesByStatus, loading, refresh: fetchLeaves };
}
